export const StripeToken = 'pk_live_9oSPFpeORunY9TLujYByEEeP';

export const googleMapURL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDYe9awS-jaxFsRJrE4iMGiO5iwlgL4gxc&libraries=places";

export const mapStyle = [
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
];

export const monthsNames = ["Jan", "Feb", "Mar", "Apr", 'May', "Jun", "Jul", "Aug", "Sep", "Nov", "Dec"];
